<template>
    <v-app class="backgroundHome">
        <img class="logoDiba" :src="logoDiba" alt="" v-show="showDibaLogo">
        <v-dialog v-model="dialog">
            <v-layout d-flex>
                <v-card>
                    <v-flex xs12>
                        <v-text-field :label="$t('password')" type="password" v-model="passwordAdmin"
                                      v-on:keyup.enter="toAdminHome"
                        ></v-text-field>
                    </v-flex>
                </v-card>
            </v-layout>
        </v-dialog>
        <!--        {{computedInformationRanking}}-->
        <v-container fluid grid-list-xl class="containerCards" v-show="this.$store.state.showHome">
            <v-layout justify-center>
                <v-flex xs10>
                    <v-card color="#FCE15C" class="elevation-12 cardHome" v-on:click="toSingleGame">
                        <v-card-title class="textCardHome">
                            <v-icon x-large class="logoutCard">play_arrow</v-icon>
                            JUGAR
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-flex xs5>
                    <v-card dark color="#2dde98" class="elevation-12 cardHome" v-on:click="toProfile()">
                        <v-card-title class="logoutCard textCardHome">
                            <v-icon x-large>account_circle</v-icon>
                            PERFIL
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs5>
                    <v-card dark color="#B78DE4" class="elevation-12 cardHome" v-on:click="toRanking()">
                        <v-card-title class="textCardHome">
                            <v-icon x-large>format_list_numbered</v-icon>
                            RANKING
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-center>
                <v-flex xs5>
                    <v-card dark color="#F5DABD" class="elevation-12 cardHome" v-on:click="openDialogPassword">
                        <v-card-title class="textCardHome">
                            <v-icon x-large>assignment</v-icon>
                            ADMIN
                        </v-card-title>
                    </v-card>
                </v-flex>
                <v-flex xs5>
                    <v-card dark color="#FF7BA3" class="elevation-12 cardHome" v-on:click="logOut">
                        <v-card-title class="logoutCard textCardHome">
                            <v-icon x-large>exit_to_app</v-icon>
                            {{$t('logout')}}
                        </v-card-title>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-layout justify-end>
                <a class="avisLegalClass " href="http://www.diba.cat/ca/avislegal"
                   target="_blank">{{$t('avisLegal')}}</a>
            </v-layout>
        </v-container>
        <AdminHome></AdminHome>
        <v-dialog v-model="$store.state.showRanking" persistent max-width="800px">
            <v-layout>
                <v-flex>
                    <Ranking></Ranking>
                </v-flex>
            </v-layout>
        </v-dialog>
    </v-app>
</template>

<script>

    import firebase from 'firebase';

    import Ranking from '../components/Ranking'
    import Crud from '../components/QuestionsCRUD'
    import AdminHome from '../components/AdminHome'
    import Profile from '../components/ProfileUser'

    import logoDiba from '../img/Marca DB DO negatiu quadrat.png'

    import Noty from 'noty'
    import 'vuejs-noty/dist/vuejs-noty.css'
    import {Trans} from '../plugins/Translation'

    import {db} from '../firebaseConfig'

    let usersRef = db.ref('Users');
    let varGame = db.ref('varGame');


    export default {
        name: "home",
        components: {
            Crud,
            Ranking,
            AdminHome,
            Profile
        },
        firebase: {
            usersRef
        },
        data() {
            return {
                rankingModel: true,
                dialog: false,
                showCrud: this.$store.state.showCrud,
                showHome: this.$store.state.showHome,
                bottomNav: 'recent',
                drawer: false,
                passwordAdmin: null,
                //variable que cambia
                passwordAdminGeneral: null,
                logoDiba: logoDiba,
                avisLegal: "www.diba.cat/ca/avislegal",
                usersRanking: [],
                uidActualUser: "",
                posicioRanking: 0,
                showDibaLogo: true,
            }
        },
        created() {
            varGame.child('passwordAdmin').on('value', snap => this.passwordAdminGeneral = snap.val());

            this.$store.commit('showHomeTrue');
            this.$store.commit('showCrudFalse');
            this.$store.commit('showVarGameFalse');


            //contador de punts a cero
            firebase.auth().onAuthStateChanged(function (user) {
                let updates = {};
                updates['Users/' + user.uid + '/' + 'pointsCorrectGame'] = 0;
                updates['Users/' + user.uid + '/' + 'pointsFailedGame'] = 0;
                updates['Users/' + user.uid + '/' + 'numberCorrectAnswersGame'] = 0;
                updates['Users/' + user.uid + '/' + 'numberFailedAnswersGame'] = 0;
                return firebase.database().ref().update(updates);
            });
            this.$store.commit('finishGameFalse');

            // control idioma al recarregar
            let lang;
            let path = window.location.pathname;

            if (path === '/jocPadro/cat/home') {
                lang = 'cat';

            } else if (path === '/jocPadro/es/home') {
                lang = 'es';
            }
            const to = this.$router.resolve({params: {lang}});
            return Trans.changeLanguage(lang).then(() => {
                this.$router.push(to.location);
            });
        },
        methods: {
            toSingleGame() {
                this.$store.commit('finishGameFalse');
                this.$router.replace('board');

            },
            openDialogPassword() {
                this.dialog = true;

            },
            toProfile() {
                this.$router.replace('profile')
            },
            toAdminHome() {
                if (this.passwordAdmin === this.passwordAdminGeneral) {

                    this.$store.commit('showAdminHomeTrue');
                    // this.$store.commit('showCrudTrue');
                    this.$store.commit('showHomeFalse');
                    this.dialog = false;
                    this.passwordAdmin = '';
                } else {
                    new Noty({
                        layout: 'topCenter',
                        type: 'error',
                        text: 'contrasenya incorrecte',
                        timeout: 2500
                    }).show();
                }
                this.passwordAdmin = "";
            },
            toRanking() {
                this.$store.commit('changeShowRankingTrue');
            },
            logOut() {
                firebase.auth().signOut().then(function () {
                    location.reload();
                });
            },
            informationRanking() {

                this.usersRanking = [];
                for (let i = 0; i < this.usersRef.length; i++) {

                    this.usersRanking.push(this.usersRef[i])
                }

                this.usersRanking.sort(function (a, b) {
                    if (a.score > b.score) {
                        return -1;
                    }
                    if (a.score < b.score) {
                        return 1;
                    }
                    // a must be equal to b
                    return 0;
                });


                //guardar l'uid de l'usuari actual
                let this2 = this;
                let jugadorAbans = "";

                firebase.auth().onAuthStateChanged(function (user) {
                    this2.uidActualUser = user.uid;
                });


                for (let i = 0; i < this.usersRef.length; i++) {
                    //troba l'usuari actual a traves del uid i el compara amb el uid de la bbdd
                    if (this.uidActualUser === this.usersRef[i]['.key']) {
                        //comparar els username de l'array ranking i els usuaris de la bbdd
                        for (let j = 0; j < this.usersRanking.length; j++) {
                            if (this.usersRef[i].username === this.usersRanking[j].username) {

                                // console.log("ranking " + (j+1)+" " + this.usersRanking[j].username);

                                this2.posicioRanking = j;

                                this.showDibaLogo = false;
                                if (j === 0) {
                                    new Noty({
                                        theme: 'mint',
                                        layout: 'top',
                                        type: 'info',
                                        text: "Ets el primer al ranking!",
                                        timeout: 4500
                                    }).show();

                                    setTimeout(() => {
                                        this.showDibaLogo = true;
                                    }, 5500)

                                } else if ((j + 1) === (this.usersRanking.length)) {
                                    this.showDibaLogo = false;
                                    new Noty({
                                        theme: 'mint',
                                        layout: 'top',
                                        type: 'error',
                                        text: "Ets l'ultim al ranking :(",
                                        timeout: 4500
                                    }).show();
                                    setTimeout(() => {
                                        this.showDibaLogo = true;
                                    }, 5500)
                                } else {

                                    this.showDibaLogo = false;

                                    jugadorAbans = this.usersRanking[(this2.posicioRanking - 1)].username;
                                    new Noty({
                                        theme: 'mint',
                                        layout: 'top',
                                        type: 'warning',
                                        text: "Et trobes a la posició " + (this2.posicioRanking + 1) + " " + jugadorAbans.toUpperCase() + " es troba per davant de tu al ranking",
                                        timeout: 5500
                                    }).show();

                                    setTimeout(() => {
                                        this.showDibaLogo = true;
                                    }, 5500)
                                }

                            }
                        }
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import url('https://fonts.googleapis.com/css?family=Josefin+Sans&display=swap');


    .avisLegalClass {
        color: white;
        font-size: 15px;
        margin-right: 50px;
        /*text-decoration: none;*/
    }

    .logoDiba {
        position: absolute;
        padding: 20px;
        width: 150px;

    }

    .backgroundHome {
        background-image: linear-gradient(to right top, #2f89fc, #00a0ff, #00b4fd, #00c5f1, #00d3e4, #29d9df, #43dfd9, #5ae5d2, #71e6d8, #86e7dc, #98e8e1, #aae9e4);
    }


    .containerCards {
        margin-top: 15%;

    }

    .textCardHome {
        color: white;
        justify-content: center;
        font-family: 'Josefin Sans', sans-serif;
        font-weight: bold;
    }

    .cardHome {
        border-radius: 10px;
        height: 90px;
    }

    .logoutCard {
        color: white;
        justify-content: center;
    }

    @media only screen and (min-width: 720px) {

    }
</style>
